import React, { useLayoutEffect, useState } from "react";
import { Helmet } from "react-helmet";
import MobileAppRedirect from "./components/app-redirect";
import { fetchContentDetails } from "./services";

const defaultData = {
  title: "Meditation Idanim App",
  description: "Idanim app deeplinking",
  image:
    "https://meditation.idanim.com/static/media/logo.822df4187eba6957f2fd.svg",
};

function App() {
  const [metaDetails, setMetaDetails] = useState(defaultData);

  const REACT_APP_IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
  const urlParams = new URLSearchParams(window.location.search);
  const contentId = urlParams.get("courseId") || urlParams.get("eventId");

  useLayoutEffect(() => {
    fetchContent();
    redirectUser();
  }, [contentId]);

  const fetchContent = async () => {
    const data = await fetchContentDetails(contentId);
    const parsedData = data?.data;
    console.log(parsedData, "parsedData");
    if (parsedData) {
      setMetaDetails({
        title: parsedData?.title || defaultData.title,
        description: parsedData?.shortDescription || defaultData.description,
        image: parsedData?.coverImage || defaultData.image,
      });
    }
  };

  const redirectUser = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let redirectUrl = "https://www.idanim.com/idanim-mobile-app-download";
    if (/android/i.test(userAgent)) {
      redirectUrl =
        "https://play.google.com/store/apps/details?id=com.ttn.idanim";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      redirectUrl = "https://apps.apple.com/us/app/idanim/id1631848467";
    }
    window.location.href = redirectUrl;
  };

  const changeImageFormat = (backgroundImageUrl) => {
    if (backgroundImageUrl.match(/\.webp$/)) {
      return backgroundImageUrl; // Return as is
    } else {
      return backgroundImageUrl.replace(/\.(jpg|png|jpeg)$/, ".webp");
    }
  };
  return (
    <div className="App">
      <Helmet>
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description} />
        <meta property="og:url" content="https://meditation.idanim.com" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={metaDetails.title} />
        <meta property="og:description" content={metaDetails.description} />
        <meta property="og:image" content={metaDetails.image} />

        <meta name="twitter:card" content={metaDetails.image} />
        <meta property="twitter:domain" content="meditation.idanim.com" />
        <meta property="twitter:url" content="https://meditation.idanim.com" />
        {/* <meta name="twitter:title" content="Meditation Idanim App-OG" /> */}
        <meta name="twitter:description" content={metaDetails.description} />
        <meta
          name="twitter:image"
          content={changeImageFormat(REACT_APP_IMAGE_URL + metaDetails.image)}
        />
      </Helmet>

      <MobileAppRedirect />
    </div>
  );
}

export default App;
